import { render, staticRenderFns } from "./ProductCode.vue?vue&type=template&id=5a631eac&scoped=true"
import script from "./ProductCode.vue?vue&type=script&lang=js"
export * from "./ProductCode.vue?vue&type=script&lang=js"
import style0 from "./ProductCode.vue?vue&type=style&index=0&id=5a631eac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a631eac",
  null
  
)

export default component.exports